import { RemixBrowser } from '@remix-run/react';
import i18next from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import Fetch from 'i18next-fetch-backend';
import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { getInitialNamespaces } from 'remix-i18next/client';
import { i18nConfig } from '#speaker-admin/i18n/config';
import { getAllPublicEnv } from '#speaker-admin/utils/public-env';

async function main() {
    const env = getAllPublicEnv();
    const translationVersion = env.NODE_ENV === 'production' ? env.COMMIT_SHA : 'development';

    // eslint-disable-next-line import/no-named-as-default-member
    await i18next.use(initReactI18next) // Tell i18next to use the react-i18next plugin
        .use(Fetch) // Tell i18next to use the Fetch backend
        .use(I18nextBrowserLanguageDetector) // Setup a client-side language detector
        .init({
            defaultNS: i18nConfig.defaultNS,
            fallbackLng: i18nConfig.fallbackLng,
            supportedLngs: i18nConfig.supportedLngs,
            ns: getInitialNamespaces(),
            detection: {
                // Here only enable htmlTag detection, we'll detect the language only
                // server-side with remix-i18next, by using the `<html lang>` attribute
                // we can communicate to the client the language detected server-side
                order: [ 'htmlTag' ],
                // Because we only use htmlTag, there's no reason to cache the language
                // on the browser, so we disable it
                caches: []
            },
            backend: {
                // We will configure the backend to fetch the translations from the
                // resource route /api/locales and pass the lng and ns as search params
                loadPath: `/api/locales?lng={{lng}}&ns={{ns}}&v=${encodeURIComponent(translationVersion)}`
            }
        });

    startTransition(() => {
        hydrateRoot(
            document,
            <I18nextProvider i18n={i18next}>
                <StrictMode>
                    <RemixBrowser />
                </StrictMode>
            </I18nextProvider>
        );
    });
}

main().catch((error) => console.error(error));
